var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boar"},[_c('div',{staticClass:"boar__wrap"},[_c('AdviceBubble'),_c('p',{staticClass:"boar__img",class:{ 'is-error': _vm.getInputStatus.error }})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }